import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const GET_PROPERTY_VIEW_API = `${LOCAL_URL}/property/viewProperty`
export const GET_UTILITY_TYPE = `${LOCAL_URL}/invoice/getUtilityTypes`
export const GENERATE_UTILITY_INVOICE = `${LOCAL_URL}/invoice/generateUtilityInvoice`

const headers = {
  Authorization: API_TOKEN,
  //'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
}

export async function ViewProperty(obj: any) {
  return axios.get(``)
}

export async function property_View(property_uuid: string) {
  return await axios.post(GET_PROPERTY_VIEW_API, {
    property_uuid,
  })
}

export interface Field {
  utility_type_id: number,
  utility_name: string,
  amount: number,
  sgst?: number,
  cgst?: number,
  gst_applicable: boolean,
}
export async function Generate_Utility_Invoice(
  property_sub_unit_uuid: string,
  property_uuid: string,
  month: string,
  utilites: Field[]) {
  return await axios.post(GENERATE_UTILITY_INVOICE, {
    property_uuid,
    property_sub_unit_uuid,
    month,
    utilites
  })
}

export async function Get_Utility_Type() {
  return await axios.get(GET_UTILITY_TYPE)
}